module.exports = __webpack_public_path__ + "static/media/burda.b9a0e565.png";